import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "../rootreducer/root-reducer";

const store = configureStore({
    reducer: rootReducer,
})

export default store;